import { Button } from "@workspace/ui/components/button";
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from "@workspace/ui/components/sheet";
import { Menu } from "lucide-react";
import { Link, NavLink } from "react-router";
import Cart from "./cart/cart";
import Logo from "./logo";

export default function Header(props) {
	return (
		<header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur-sm supports-backdrop-filter:bg-background/60">
			<div className="container flex h-16 items-center justify-between gap-2 md:gap-4">
				<div className="mr-4 hidden md:flex">
					<a className="mr-6 flex items-center space-x-2" href="/">
						<Logo className="h-auto w-48" />
					</a>
					<nav className="flex items-center space-x-6 font-medium text-sm">
						{props.items.map((item) => (
							<NavLink
								key={item.path}
								className={({ isActive }) =>
									`text-foreground/60 transition-colors hover:text-foreground/80 ${isActive ? "text-primary" : ""}`
								}
								to={item.path}
								prefetch="intent"
							>
								{item.name}
							</NavLink>
						))}
					</nav>
				</div>
				<Sheet>
					<SheetTrigger asChild>
						<Button
							variant="ghost"
							className="mr-2 px-0 text-base hover:bg-transparent focus-visible:bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 md:hidden"
						>
							<Menu className="h-6 w-6" />
							<span className="sr-only">Toggle Menu</span>
						</Button>
					</SheetTrigger>
					<SheetContent side="left" className="pr-0">
						<SheetHeader>
							<SheetTitle>Meny</SheetTitle>
						</SheetHeader>
						<nav className="flex flex-col gap-4 px-7 py-4 font-medium text-2xl">
							{props.items.map((item) => (
								<NavLink
									key={item.path}
									className={({ isActive }) =>
										`hover:underline ${isActive ? "text-primary" : ""}`
									}
									to={item.path}
									prefetch="intent"
								>
									{item.name}
								</NavLink>
							))}
						</nav>
					</SheetContent>
				</Sheet>
				<a className="mr-6 flex items-center space-x-2" href="/">
					<Logo className="h-auto w-48 md:hidden" />
				</a>
				<div className="flex items-center justify-between space-x-2 md:justify-end">
					<Cart />
				</div>
			</div>
		</header>
	);
}
